import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Button from "common/components/Button/Button"
import { ArticulosSkeletons } from "common/components/skeletons/ArticuloSkeleton"
import createImgURI from "common/utils/createImgURI"
import { formatCurrency } from "common/utils/currency"
import { newDocumentoSelectorDoc } from "features/Crear/redux/slices/newDocumentoSlice"
import { useSelector } from "hooks/useSelector"
import { forwardRef, useEffect } from "react"
import { useTranslation } from "react-i18next"

const ArticuloItem = ({
  articulosIdSelected,
  addArticulo,
  handleChangeCantidad,
  agregarCantidad,
  sinValorar,
  item,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  return (
    <div className='articulo-catalogo'>
      <div className='wrap-left'>
        <div className='articulo-image'>
          {item.thumbnailBase64 === null ? (
            <FontAwesomeIcon
              icon={["fal", "camera-slash"]}
              className='icon-size-lg'
            />
          ) : (
            <img
              src={createImgURI(item.thumbnailBase64, item.fichero?.mediaType)}
              alt='imagen'
              className='object-fit'
            />
          )}
        </div>

        <span className='articulo-referencia'>{item.numeroReferencia}</span>

        <span className='articulo-name'>{item.concepto}</span>
      </div>

      <div className={sinValorar ? " mt-2 " : "wrap-right"}>
        {!articulosIdSelected[item.id] ? (
          <Button
            onClick={() => addArticulo(item)}
            className='outlined'
            style={{ minWidth: "200px" }}
          >
            <FontAwesomeIcon
              className='mr-2'
              icon={["fal", "cart-shopping"]}
            />{" "}
            {t("crear.facturaRec.addLabel")}
          </Button>
        ) : (
          <div className='flex items-center justify-start'>
            <div
              onClick={() =>
                agregarCantidad({
                  articulo: articulosIdSelected[item.id],
                  sum: -1,
                })
              }
              className='flex items-center justify-center py-2 rounded-l shadow-sm w-1-4 border-1 border-gray pointer'
            >
              <FontAwesomeIcon
                className='icon-size-lg'
                icon={["fal", "minus"]}
              />
            </div>

            <input
              min={0}
              value={articulosIdSelected[item.id]?.cantidad}
              onChange={(e) =>
                handleChangeCantidad({
                  articulo: articulosIdSelected[item.id],
                  cantidad: e.target.value,
                })
              }
              type='number'
              className='flex items-center justify-center py-2 text-center outarrows w-2-4 bg-bone border-gray border-1'
            />

            <div
              className='flex items-center justify-center py-2 rounded-r shadow-sm w-1-4 border-1 border-gray pointer'
              onClick={() =>
                agregarCantidad({
                  articulo: articulosIdSelected[item.id],
                })
              }
            >
              <FontAwesomeIcon
                icon={["fal", "plus"]}
                className='icon-size-lg'
              />
            </div>
          </div>
        )}

        {!sinValorar && (
          <span className='articulo-precio'>
            {formatCurrency(item.precioVenta)}
          </span>
        )}
      </div>
    </div>
  )
}

const ArticulosList = forwardRef(
  (
    {
      // @ts-expect-error TS(2339): Property 'articulos' does not exist on type '{}'.
      articulos,
      // @ts-expect-error TS(2339): Property 'articulosIdSelected' does not exist on t...
      articulosIdSelected,
      // @ts-expect-error TS(2339): Property 'addArticulo' does not exist on type '{}'...
      addArticulo,
      // @ts-expect-error TS(2339): Property 'handleChangeCantidad' does not exist on ...
      handleChangeCantidad,
      // @ts-expect-error TS(2339): Property 'agregarCantidad' does not exist on type ...
      agregarCantidad,
      // @ts-expect-error TS(2339): Property 'title' does not exist on type '{}'.
      title,
      // @ts-expect-error TS(2339): Property 'sinValorar' does not exist on type '{}'.
      sinValorar,
      // @ts-expect-error TS(2339): Property 'loading' does not exist on type '{}'.
      loading,
      // @ts-expect-error TS(2339): Property 'loadingMore' does not exist on type '{}'...
      loadingMore,
      // @ts-expect-error TS(2339): Property 'itemsLayout' does not exist on type '{}'...
      itemsLayout = true,
      // @ts-expect-error TS(2339): Property 'generarPresupuesto' does not exist on ty...
      generarPresupuesto,
    },
    ref
  ) => {
    const { t } = useTranslation()
    const objetoDocumento = useSelector(newDocumentoSelectorDoc)

    useEffect(() => {
      objetoDocumento?.conceptos?.length > 0 && generarPresupuesto()
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if (!articulos.length && !loadingMore && !loading) {
      return (
        <div
          className='d-flex justify-content-center align-items-center'
          style={{ height: "35vh" }}
        >
          <div className='div'>
            <h6>{t("crear.facturaRec.noArticlesList")}</h6>

            <Button
              className='!tw-bg-primary'
              onClick={generarPresupuesto}
              label={`${t("crear.facturaRec.generateLabel")}${title}`}
            />
          </div>
        </div>
      )
    }

    return (
      <div
        className={`categoria-items mt-3 p-1 ${
          itemsLayout ? "items-layout" : ""
        }`}
      >
        {loading ? (
          <ArticulosSkeletons times={20} />
        ) : (
          articulos?.map((item: $TSMigrationFixMe) => (
            <ArticuloItem
              key={item.id}
              item={item}
              sinValorar={sinValorar}
              articulosIdSelected={articulosIdSelected}
              addArticulo={addArticulo}
              handleChangeCantidad={handleChangeCantidad}
              agregarCantidad={agregarCantidad}
            />
          ))
        )}

        {/* @ts-expect-error TS(2322): Type 'ForwardedRef<unknown>' is not assignable to ... */}
        <div ref={ref} />
        {loadingMore && <ArticulosSkeletons times={20} />}
      </div>
    )
  }
)

export default ArticulosList
